import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type GetDealStatusParams = {
  rfsId: string;
  attempt: number;
};

export const getDealStatus = (builder: WebapiEndpointBuilder) => {
  return builder.query<boolean, GetDealStatusParams>({
    query: ({ rfsId }) => {
      return {
        url: '/deal/status',
        params: { rfsId },
        method: 'GET',
        timeout: 2000,
      };
    },
  });
};
